import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SubsectorService } from '../../../services/subsector';
import { CustomerAddressService } from '../../../services/customeraddress';
import { CustomerService } from '../../../services/customer';
import { Subsector } from '../../../interfaces/subsector.interface';
import { CustomerAddress } from '../../../interfaces/customeraddress.interface';
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-add-customeraddress',
  imports: [ReactiveFormsModule],
  templateUrl: './add-customeraddress.html',
  styleUrl: './add-customeraddress.css'
})

export class AddCustomerAddressComponent implements OnInit {
subsectors: Subsector[] = [];
selectedCustomeraddress: CustomerAddress = {} as CustomerAddress;
myForm: FormGroup;
submitted: boolean = false;

constructor(  private subsectorService: SubsectorService,
              private customeraddressService: CustomerAddressService,
              private customerService: CustomerService,
              private router: Router,
              private cdr: ChangeDetectorRef,
              private fb: FormBuilder){
                this.myForm = this.fb.group({
                customercode: new FormControl('',[Validators.maxLength(30)]),
                addressserial: new FormControl('',[Validators.maxLength(10)]),
                subsectorcode: new FormControl('', [Validators.required, Validators.maxLength(25)]),
                salesareacode: new FormControl('',[Validators.maxLength(100)]),
                accountcode: new FormControl('',[Validators.maxLength(25)]),
                ordercode: new FormControl('',[Validators.maxLength(25)]),
                addressline1: new FormControl('',[Validators.required,Validators.minLength(3),Validators.maxLength(100)]), 
                addressline2: new FormControl('',[Validators.maxLength(100)]),
                addresszip: new FormControl('',[Validators.required,Validators.maxLength(10)]),
                uploadSelected: new FormControl(true),
                uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)])
              }) //}, { updateOn: 'submit' });
            };

async ngOnInit(): Promise<void> 
{
   // make sure we have a customer selected
   if (typeof this.customerService.selectedCustomer === undefined || this.customerService.selectedCustomer.customercode === undefined)
        {
          this.router.navigateByUrl('customer'); ;
          return;
        }
   try 
    {
      this.subsectors = await this.subsectorService.getSubsector();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getsubsector',error);
    }

      this.selectedCustomeraddress = this.customeraddressService.editcustomeraddress;
      //this.myForm.value.customercode = this.customerService.selectedCustomer.customercode;
      this.myForm.get('customercode')?.setValue(this.customerService.selectedCustomer.customercode);
      this.cdr.detectChanges();

      //this.customercode = this.selectedCustomeraddress.customercode;
}

async addCustomerAddress(): Promise<void> 
{
         // id
        // distid
        // uploaded
        var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";       
        var addressserial = this.myForm.value.addressserial != null ? this.myForm.value.addressserial.trim() : "";
        var salesareacode = this.myForm.value.salesareacode != null ? this.myForm.value.salesareacode.trim() : "";
        var subsectorcode = this.myForm.value.subsectorcode != null ? this.myForm.value.subsectorcode.trim() : "";
        var accountcode = this.myForm.value.accountcode != null ? this.myForm.value.accountcode.trim() : "";
        var ordercode = this.myForm.value.ordercode != null ? this.myForm.value.ordercode.trim() : "";
        var addressline1 = this.myForm.value.addressline1 != null ? this.myForm.value.addressline1.trim() : "";
        var addressline2 = this.myForm.value.addressline2 != null ? this.myForm.value.addressline2.trim() : "";
        var addresszip = this.myForm.value.addresszip != null ? this.myForm.value.addresszip.trim() : "";
        var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";
        var uploadSelected = this.myForm.value.uploadSelected;

      if (uploadSelected)
      {
        uploaded = "0000-00-00";
      }

         try
        {
          await this.customeraddressService.create(customercode,addressserial,salesareacode,subsectorcode,accountcode,ordercode,addressline1,addressline2,addresszip,uploaded)
          this.cdr.detectChanges();
          //this.getCustomeraddresses();
          this.router.navigateByUrl('customeraddress');        
        } catch (error) {
          console.error('addcustomer',error);
          throw error;
        }
    }
get customercode() {
    return this.myForm.get('customercode');
  }
  get subsectorcode() {
    return this.myForm.get('subsectorcode');
  }
  get salesareacode() {
    return this.myForm.get('salesareacode');
  }
  get ordercode() {
    return this.myForm.get('ordercode');
  }
  get addressline1() {
    return this.myForm.get('addressline1');
  }
  get addressline2() {
    return this.myForm.get('addressline2');
  }
  get addresszip() {
    return this.myForm.get('addresszip');
  }
  get uploaded() {
    return this.myForm.get('uploaded');
  }
  get uploadSelected() {
    return this.myForm.get('uploadedSelected');
  }
goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('customeraddress');
  }
}